import { Link, useLocation, useParams } from "react-router-dom";
import "./CrmMenu.css";
import React, { useContext, useEffect } from "react";
import AppContext from "../../../../context/AppContext";
import { useAuth } from "../../../../context/AuthContext";

function CrmMenu({ isNetwork, isAgency }) {
  const { setBannerConfig } = useContext(AppContext);
  const menuItems = [
    {
      id: 1,
      label: "Utilisateurs",
      to: "utilisateurs",
      visibleForNetwork: true,
      visibleForAgency: true,
    },
    {
      id: 2,
      label: "Estimations",
      to: "estimations",
      visibleForNetwork: true,
    },
    {
      id: 3,
      label: "Statistiques",
      to: "statistiques",
      visibleForNetwork: true,
      visibleForAgency: true,
    },
    {
      id: 4,
      label: "Algorithme",
      to: "algorithme",
    },
    {
      id: 5,
      label: "Conseils de pros",
      to: "editeur-articles",
    },
    {
      id: 6,
      label: "Trucs & astuces",
      to: "editeur-trucs-astuces",
    },
    {
      id: 7,
      label: "Lexique",
      to: "lexique",
    },
    {
      id: 8,
      label: "F.A.Q",
      to: "faq",
    },
    {
      id: 9,
      label: "Outils pratiques",
      to: "outils-pratiques",
    },
  ];
  const location = useLocation();
  const { userData } = useAuth();

  useEffect(() => {
    setBannerConfig({
      title: <>CRM - Menu</>,
      subtitle: <></>,
    });
  }, []);

  function getItemLink(item, userData) {
    if (!isNetwork && !isAgency) return "/admin/crm/" + item.to;

    const param = isNetwork ? userData?.partner_id : userData?.agency_id;
    return location.pathname + "/" + item.to + "/" + param;
  }

  function isItemVisible(item, isNetwork, isAgency) {
    if (isAgency && item.visibleForAgency && userData?.agency_id) return true;
    if (isNetwork && item.visibleForNetwork && userData?.partner_id) return true;
    if (!isAgency && !isNetwork) return true;
  }

  return (
    <div className='page-container container'>
      <div className='crm-menu-container'>
        {menuItems.map(
          item =>
            isItemVisible(item, isNetwork, isAgency, userData) && (
              <Link to={getItemLink(item, userData)} className='crm-menu-item' key={item.id}>
                {item.label}
              </Link>
            ),
        )}
      </div>
    </div>
  );
}

export default CrmMenu;
